import type { MotorsQueryVariables, Motors_Bool_Exp } from "gql/api";
import { Order_By } from "gql/api";

export function deleteMotors(arr: Array<string>): Motors_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export function restoreMotors(arr: Array<string>): Motors_Bool_Exp {
  if (!arr) return {};
  return { id: { _in: arr } };
}

export const defaultMotorVars: MotorsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { nameplate_horsepower: Order_By.Asc }
  ],
  where: {
    is_hps: { _eq: true }
  }
};

export const adminMotorVars: MotorsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { nameplate_horsepower: Order_By.Asc }
  ],
  where: {
    is_hps: { _eq: true }
  }
};

export const kocMotorVars: MotorsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { nameplate_horsepower: Order_By.Asc }
  ],
  where: {
    _and: [
      {
        _or: [
          { include_koc_timestamp: { _is_null: false } },
          { only_koc_timestamp: { _is_null: false } }
        ]
      },
      { is_hps: { _eq: true } }
    ]
  }
};

export const ecopetrolMotorVars: MotorsQueryVariables = {
  order_by: [
    { prioritized_manufacturer: Order_By.Asc },
    { nameplate_horsepower: Order_By.Asc }
  ],
  where: {
    _and: [
      {
        _or: [
          { include_ecopetrol_timestamp: { _is_null: false } },
          { only_ecopetrol_timestamp: { _is_null: false } }
        ]
      },
      { is_hps: { _eq: true } }
    ]
  }
};
